import React from 'react';
import { Messages } from '../../../../../../gen-src/Localize';
import {
  PlaceholderTextCell,
  TableauUser,
  TypedBodyCellProps,
  UserLinkDisplayComponent
} from '../../../../data-catalog-shared';
import { LinkCellFormatter } from './LinkCellFormatter';

export function createUserNameLinkCellFormatter<TRowData>(
  getUserFromRowData: (rowData: TRowData) => TableauUser | null,
  disableTabIndex = false,
  getDisabledFromRowData?: (rowData: TRowData) => boolean,
): React.Factory<TypedBodyCellProps<TRowData>> {

  return function UserNameLinkCell(props: TypedBodyCellProps<TRowData>) {
    return (
      <UserLinkDisplayComponent
        user={getUserFromRowData(props.row.data)}
        linkComponent={
          ({ name, pathname }) =>
            <LinkCellFormatter
              text={name}
              pathname={pathname}
              noPadding={false}
              disableTabIndex={disableTabIndex}
              disabled={getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false}
            />
        }
        hiddenUserElement={<PlaceholderTextCell placeholderText={Messages.HiddenUser()} />}
        noneUserElement={<PlaceholderTextCell placeholderText={Messages.None()} />}
      />
    );
  };
}
